import { ApiQueryBuilder } from "@/hooks/use-api-query";
import { IRootAdminResponse } from "@portafino/shared";
import { QueryKey } from "@/utils/query-key";

export const GetAuthenticatedRootAdmin: ApiQueryBuilder<IRootAdminResponse, void> = () => {
    return {
        queryKey: [QueryKey.AuthenticatedRootAdmin],
        queryFn: async (apiClient) => {
            const response = await apiClient.get<IRootAdminResponse>(`/root-admins/auth/me`)
            return response.data
        }
    }
}